import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTeacherWhiteboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTeacherWhiteboard"><Path d="M11.5 4V3H9.5V4H1V6H2V16H1V18H10V16H4V6H17V7H19V6H20V4H11.5Z" fill="currentColor"/><Path d="M17 9C15.3431 9 14 10.3431 14 12C14 13.6569 15.3431 15 17 15C18.6569 15 20 13.6569 20 12C20 10.3431 18.6569 9 17 9Z" fill="currentColor"/><Path d="M17 15.5C14.2516 15.5 12.253 17.4268 12.005 19.9002L11.8947 21H22.1053L21.995 19.9002C21.747 17.4268 19.7484 15.5 17 15.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTeacherWhiteboard;
